module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d79b7cfa0e997d7247c9d5761d75ff3f.png";